import React from "react";
import { Link } from "react-router-dom";
import { GsdReadableBlock, useI18n } from "@/coquille-bridge";
import { PageSection } from "@/components/AppLayout.jsx";
import { getAdminNavGroups } from "@/config/karateAdminNavGroups.js";

function useLocale() {
  const { lang } = useI18n();
  return lang === "en" ? "en" : "fr";
}

function AdminNavHubPage({ groupId, testId }) {
  const locale = useLocale();
  const group = getAdminNavGroups(locale).find((g) => g.id === groupId);

  if (!group) {
    return (
      <PageSection title="—" testId={testId}>
        <p>Section introuvable.</p>
      </PageSection>
    );
  }

  return (
    <div data-testid={testId}>
      <PageSection title={group.label} subtitle={locale === "en" ? "Phase 1 · demo" : "Phase 1 · démo"} testId={`${testId}-header`}>
        <div className="admin-nav-hub__grid">
          {group.items.map((item) => (
            <GsdReadableBlock key={item.id} testId={`${testId}-card-${item.id}`} className="admin-nav-hub__card-wrap">
              <Link to={item.to} className="admin-nav-hub__card" data-testid={`${testId}-link-${item.id}`}>
                <span className="admin-nav-hub__card-icon" aria-hidden="true">
                  {item.icon || "•"}
                </span>
                <span className="admin-nav-hub__card-title">{item.label}</span>
                <span className="admin-nav-hub__card-meta muted">Phase 1</span>
              </Link>
            </GsdReadableBlock>
          ))}
        </div>
      </PageSection>
    </div>
  );
}

export function AdminOrganisationHubPage() {
  return <AdminNavHubPage groupId="organisation" testId="page-admin-organisation-hub" />;
}

export function AdminActivitesHubPage() {
  return <AdminNavHubPage groupId="activites" testId="page-admin-activites-hub" />;
}

export function AdminProgressionHubPage() {
  return <AdminNavHubPage groupId="progression" testId="page-admin-progression-hub" />;
}

export function AdminAdministrationHubPage() {
  return <AdminNavHubPage groupId="administration" testId="page-admin-administration-hub" />;
}
